import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions } from 'ag-grid-community';
import { FileDataStore } from '../../../../store/file-data.store';
import { AgPaginatorComponent } from '../../../ag-grid-components/ag-paginator/ag-paginator.component';
import { DownloadIconRendererComponent } from '../../../ag-grid-components/download-icon-renderer/download-icon-renderer.component';

export interface AsmFilesGridRow {
  rowToken: string;
  createDate: Date;
  payerAlias: string;
  createdBy: string;
  recordCount: number;
  templateName: string;
  statusUpdated: number;
}

@Component({
    selector: 'app-asm-files-grid',
    imports: [AgGridModule],
    templateUrl: './asm-files-grid.component.html',
    styleUrl: './asm-files-grid.component.scss'
})
export class AsmFilesGridComponent {
  readonly store = inject(FileDataStore);
  readonly datePipe = inject(DatePipe);
  readonly mode = 'asm';

  gridOptions: GridOptions = {
    defaultColDef: {
      suppressMovable: true,
      suppressHeaderMenuButton: true
    },
    columnDefs: [
      {
        field: "rowToken",
        hide: true
      },
      { 
        field: "createDate", 
        headerName: "Create Date/Time", 
        flex: 1,
        valueFormatter: (params) => { return this.datePipe.transform(params.data?.createDate, "MM/dd/yyyy hh:mm a") ?? ""; }
      },
      { field: "payerAlias", headerName: "Payer", flex: 1 },
      { field: "createdBy", headerName: "Created By", flex: 1 },
      {
        field: "recordCount",
        headerName: "Record Count",
        flex: 1,
      },
      {
        field: "statusUpdated",
        headerName: "Oppty Status Updated",
        flex: 1,
        valueFormatter: (params) => { return params.data?.statusUpdated === 1 ? 'Yes' : 'No'; }
      },
      {
        field: "templateName",
        headerName: "Template Name",
        flex: 1,
      },
      {
        field: "action",
        headerName: "Action",
        minWidth: 84,
        maxWidth: 84,
        cellRenderer: "downloadRenderer",
        sortable: false,
      },
    ],
    statusBar: {
      statusPanels: [
        {
          statusPanel: AgPaginatorComponent,
          key: "ag-paginator",
        },
      ],
    },
    paginationPageSize: 25,
    paginationPageSizeSelector: [25, 50, 100, 150, 300],
  };

  gridComponents = {
    downloadRenderer: DownloadIconRendererComponent,
  };

  onDownloadClicked(rowToken: string) {
    this.store.downloadFile(rowToken, this.mode);
  }
}
